// extracted by mini-css-extract-plugin
module.exports = {"container":"AV","addOrRemoveFromListButton":"AW","addOrRemoveFromListIcon":"AX","checkIconStyle":"AY","cta":"AZ"};